/** Zone every schedule in the payload is authored in when the tenant is silent. */
export const DEFAULT_TENANT_TIMEZONE = "America/Sao_Paulo"

let current = DEFAULT_TENANT_TIMEZONE

function isSupported(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone })
    return true
  } catch {
    return false
  }
}

/**
 * Adopts the tenant zone published by the scheduling context (§2A.4). An empty
 * or unsupported zone keeps the previous one — never the customer's clock,
 * which is what the schedules are precisely not authored in.
 */
export function setTenantTimezone(timezone: string | null | undefined): void {
  if (!timezone || !isSupported(timezone)) return
  current = timezone
}

/** The tenant zone in force; Sao Paulo fallback until a context resolves. */
export function getTenantTimezone(): string {
  return current
}

/** Explicit zone when the caller has one, the tenant zone otherwise. */
export function resolveTenantTimezone(timeZone?: string | null): string {
  return timeZone && isSupported(timeZone) ? timeZone : current
}

/** Test seam: drops back to the default zone. */
export function resetTenantTimezone(): void {
  current = DEFAULT_TENANT_TIMEZONE
}
